class RapidResponseAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.boundOnTriggerClick = this.onTriggerClick.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.rrh-accordion__item'));

    this.items.forEach((item) => {
      const trigger = item.querySelector('.rrh-accordion__trigger');
      trigger?.addEventListener('click', this.boundOnTriggerClick);
    });
  }

  disconnectedCallback() {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.rrh-accordion__trigger');
      trigger?.removeEventListener('click', this.boundOnTriggerClick);
    });
  }

  onTriggerClick(event) {
    const item = event.currentTarget.closest('.rrh-accordion__item');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');

    this.items.forEach((panel) => {
      this.setPanelOpen(panel, false);
    });

    if (!isOpen) {
      this.setPanelOpen(item, true);
    }
  }

  setPanelOpen(item, isOpen) {
    const trigger = item.querySelector('.rrh-accordion__trigger');
    const content = item.querySelector('.rrh-accordion__content');

    item.classList.toggle('is-open', isOpen);
    trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (content) {
      content.hidden = !isOpen;
    }
  }
}

customElements.define('rapid-response-accordion', RapidResponseAccordion);
